module.exports = __webpack_public_path__ + "static/media/gamepad.fa3c431b.svg";